/* XMYPICK Beauty: lazy, muted, looping autoplay for product-page videos (snippet xb-beauty-video).
   - The video URL waits in data-src until the card is within 200px of
     the viewport, so nothing downloads at page open; autoplay + muted then start it without a click.
   - Videos pause when scrolled away and resume when back, unless the visitor paused them.
   - prefers-reduced-motion: no autoplay; the button plays on request.
   Loaded with defer by the sections that render videos; the guard makes repeat includes harmless. */
(function () {
  if (window.__xbBeautyMedia) return;
  window.__xbBeautyMedia = true;

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function init(wrap) {
    if (wrap.getAttribute('data-xb-ready')) return;
    wrap.setAttribute('data-xb-ready', '1');
    var video = wrap.querySelector('video');
    var button = wrap.querySelector('[data-xb-video-toggle]');
    if (!video) return;
    var loaded = false;

    function load() {
      if (loaded) return;
      loaded = true;
      var src = video.getAttribute('data-src');
      if (!src) return;
      video.setAttribute('src', src);
      video.load();
    }

    function setState(playing) {
      wrap.classList.toggle('is-paused', !playing);
      if (!button) return;
      button.setAttribute('aria-label', playing ? button.getAttribute('data-pause-label') : button.getAttribute('data-play-label'));
    }

    function play() {
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () { setState(false); });
    }

    video.addEventListener('playing', function () { setState(true); });
    video.addEventListener('pause', function () { setState(false); });

    if (reduce.matches) {
      video.removeAttribute('autoplay');
      video.autoplay = false;
      wrap.setAttribute('data-user-paused', '1');
    }

    if (button) {
      button.addEventListener('click', function () {
        load();
        if (video.paused) {
          wrap.removeAttribute('data-user-paused');
          play();
        } else {
          wrap.setAttribute('data-user-paused', '1');
          video.pause();
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      load();
      if (!wrap.getAttribute('data-user-paused')) play();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          load();
          if (!wrap.getAttribute('data-user-paused')) play();
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    observer.observe(wrap);
  }

  function scan(root) {
    var items = (root || document).querySelectorAll('[data-xb-video]');
    for (var i = 0; i < items.length; i++) init(items[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
